import { Utils } from "../utilities/Utils";

export interface ILookupItem {
    id: number | string; // number or string (GUIDs)???
    description: string;
    isArchived: boolean;
}

export class LookupItem implements ILookupItem {
    constructor(data?: ILookupItem) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: ILookupItem) {
        Utils.clone(data, this);
    }

    id = 0;
    description = "";
    isArchived = false;

    get isNew() {
        return Utils.isEmptyId(this.id);
    }
}